import { MbeCheck } from '@/components/icons';
import { Loader } from '@/components/shared';
import { ROUTE_PATHS } from '@/constants';
import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { Suspense } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PlainLayout } from '../layout';
import { Section } from '../components/Section';

export const PasswordRecoveryConfirmation = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PlainLayout>
      <Suspense fallback={<Loader />}>
        <Section
          containerProps={{ py: 0, gap: { base: 8, md: 16 } }}
          headingProps={{ mt: 0 }}
          id="signup-success-section"
        >
          <Flex
            alignItems="center"
            direction="column"
            gap={6}
            px={{ base: 8, md: 16, xl: 44 }}
            py={{ base: 10, md: 24 }}
          >
            <Icon as={MbeCheck} h={24} w={24} />
            <Text
              fontSize={{ base: 'h1.base', md: 'h1.mb' }}
              fontWeight="bold"
              maxW={{ base: '100%', md: '55%' }}
              textAlign="center"
            >
              <Trans i18nKey={'LOGIN.PASSWORD_RESET_CONFIRMATION.TITLE'} />
            </Text>

            <Button as="a" href={`/${ROUTE_PATHS.userLogin}`} my={6} variant="mbePrimary">
              {t('LOGIN.PASSWORD_RESET_CONFIRMATION.CTA')}
            </Button>
          </Flex>
        </Section>
      </Suspense>
    </PlainLayout>
  );
};
